import './MorningstarRegistrationCallback.scss';
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getQueryParams } from 'state/session/SessionSelectors';
import { getMorningstarRegistrationCallback } from 'services/Rest';
import LinkButton from 'components/shared/Buttons/LinkButton';
import { morningstarHomepageUrl } from 'services/Externals';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/success-check.svg';
import { ERROR_MORNINGSTAR_REGISTRATION_CALLBACK } from 'state/morningstar/MorningstarActions';
import { mapProductTypeToiiFooterBoolean } from 'state/account/AccountSelectors';
import AAMFooterContainer from '../Footer/FooterUtil';
import { isMobile } from 'state/view/ViewSelectors';

export const MorningstarRegistrationCallback = ({
  footerProductTypes,
  isMobileApp,
  params
}) => {
  const { finderId, offerCode } = params;
  const [registrationError, setRegistrationError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const promoCode = offerCode || finderId;

  useEffect(() => {
    if (promoCode) {
      getMorningstarRegistrationCallback(promoCode).then((response) => {
        setRegistrationError(
          response.type === ERROR_MORNINGSTAR_REGISTRATION_CALLBACK
        );
        setIsLoading(false);
      });
    }
  }, [promoCode]);

  return (
    !isLoading && (
      <Fragment>
        <div className="mstar-registration-confirmation-container">
          {registrationError && (
            <div>
              <WarningIcon />
              <p className="mstar-registration-confirmation-heading">
                We weren’t able to submit your subscription request.
              </p>
              <p className="mstar-registration-confirmation-subtext">
                We encountered a technical error and your request was not
                submitted.
                <br />
                <br />
                Please try again on your T. Rowe Price dashboard.
              </p>
            </div>
          )}
          {!registrationError && (
            <div>
              <CheckIcon />
              <p className="mstar-registration-confirmation-heading">
                Thank you!
              </p>
              <p className="mstar-registration-confirmation-subtext">
                Your Morningstar subscription was submitted successfully.
              </p>
              <LinkButton
                link={morningstarHomepageUrl}
                linkTarget={'_blank'}
                className="mstar-homepage-link"
                text="Return to Morningstar"
              />
            </div>
          )}
        </div>
        <AAMFooterContainer
          isMobileParam={isMobileApp}
          footerProductTypes={footerProductTypes}
          appLoaded={true}
        />
      </Fragment>
    )
  );
};

const mapStateToProps = (state) => ({
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  isMobileApp: isMobile(state),
  params: getQueryParams(state)
});

export default withRouter(
  connect(mapStateToProps)(MorningstarRegistrationCallback)
);
